import { Row } from '../SingleItem/OptionGroups/OptionList';
import { Product } from '../../generated/graphql';

export const getAppPrices = (
  item: Product,
  isSameOnAllApps: boolean,
  initPosPrice: number | null,
  venueName: string,
  hasBrands: boolean,
  itemHasSurcharge: boolean
): Row[] => {
  const response: Row[] = [];

  if (isSameOnAllApps) {
    response.push({
      apps: item.variablesByApp.map(({ app }) => app).sort((a, b) => a.name.localeCompare(b.name)),
      id: item.posId,
      prices: [
        {
          id: item.variablesByApp[0].app.id,
          prices: [item.variablesByApp[0].price]
        }
      ],
      _typename: item.__typename || 'Product'
    });
  } else {
    response.push(
      ...item.variablesByApp.map(({ app, price, surcharge }) => ({
        apps: [app],
        prices: [
          {
            id: app.id,
            prices: [price]
          }
        ],
        surcharge,
        ...(itemHasSurcharge &&
          surcharge &&
          surcharge?.amount > 0 && {
            disabled: true
          }),
        // eslint-disable-next-line no-nested-ternary
        label: app.brand ? `${app.name} (${app.brand.name})` : hasBrands ? `${app.name} (${venueName})` : app.name,
        id: `${item.posId}-${app.id}`,
        _typename: item.__typename || 'Product'
      }))
    );
  }

  response.sort((a, b) => a.apps?.[0]?.name.localeCompare(b.apps?.[0].name ?? '') ?? 0);

  if (initPosPrice) {
    response.push({
      apps: [
        {
          id: '1',
          name: 'Your POS',
          image: '/Images/YourPos.png'
        }
      ],
      prices: [
        {
          id: '-1',
          prices: [initPosPrice],
          disabled: true
        }
      ],
      label: 'Your POS',
      _typename: 'Product'
    });
  }

  return response;
};
